import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  signal,
  type SimpleChanges,
} from '@angular/core';

import { AdminsAvatarsComponent, type AvatarUser } from '@core/account-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { RenderDirective } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorBasicConfig,
  ProsemirrorBasicConfigDirective,
} from '@core/prosemirror-legacy/webapp';
import { SymbolComponent } from '@core/symbol-legacy';
import { ButtonComponent, HeadingComponent, IconComponent } from '@core/user-interface-legacy';
import type { LayoutListRowComponent } from '@core/views-util';
import { assigneeToAvatarUser } from '@tellent-ask-hr/core-smart-ui';
import type { AskTemplateViewItem } from '@tellent-ask-hr/core-types';

import { ChatUserTemplatesDataSourceService } from '../chat-user-templates-data-source.service';

@Component({
  selector: 'asks-form-list-item',
  imports: [
    CommonModule,
    HeadingComponent,
    ProsemirrorBasicConfigDirective,
    RenderDirective,
    ButtonComponent,
    IconComponent,
    TranslatePipe,
    SymbolComponent,
    AdminsAvatarsComponent,
  ],
  templateUrl: './chat-user-form-list-item.component.html',
  styleUrl: './chat-user-form-list-item.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'rt-card rt-card-clickable',
    '(click)': 'onClick()',
  },
})
export class UserFormListItemComponent implements LayoutListRowComponent<AskTemplateViewItem> {
  private readonly userTemplatesDataSourceService = inject(ChatUserTemplatesDataSourceService);
  protected readonly ProsemirrorBasicConfig = ProsemirrorBasicConfig;

  @Input() public record: LayoutListRowComponent<AskTemplateViewItem>['record'];
  @Input()
  public fieldsVisibilityMap: LayoutListRowComponent<AskTemplateViewItem>['fieldsVisibilityMap'];

  protected assignedUsers = signal<AvatarUser[]>([]);

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.record && this.record) {
      this.assignedUsers.set(
        this.record.autoAssignees.map(assignee => assigneeToAvatarUser(assignee)),
      );
    }
  }

  protected onClick(): void {
    this.userTemplatesDataSourceService.openNewTicket(this.record.id);
  }
}
